import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, TrendingDown, Calendar } from 'lucide-react';
import { Button } from './ui/button';

const OpeningThisWeek = ({ movies = [], loading = false }) => {
  if (loading || movies.length === 0) {
    return (
      <section data-testid="opening-section">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#F59E0B]/20 rounded-xl flex items-center justify-center">
              <Calendar className="w-5 h-5 text-[#F59E0B]" />
            </div>
            <div>
              <h2 className="text-[#F8FAFC] font-bold text-xl font-heading">Trending Now</h2>
              <p className="text-[#64748B] text-sm">Hottest securities by price change</p>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1,2,3].map(i => <div key={i} className="h-72 bg-[#121826] rounded-2xl border border-[#1E293B] animate-pulse" />)}
          </div>
        ) : (
          <div className="bg-[#121826] rounded-2xl border border-[#1E293B] p-8 text-center">
            <p className="text-[#64748B]">No trending securities right now</p>
          </div>
        )}
      </section>
    );
  }

  return (
    <section data-testid="opening-section">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#F59E0B]/20 rounded-xl flex items-center justify-center">
            <Calendar className="w-5 h-5 text-[#F59E0B]" />
          </div>
          <div>
            <h2 className="text-[#F8FAFC] font-bold text-xl font-heading">Trending Now</h2>
            <p className="text-[#64748B] text-sm">Hottest securities by price change</p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {movies.slice(0, 6).map((s) => {
          const isUp = (s.change_percent || 0) >= 0;
          const imgUrl = s.poster_url || s.photo_url;
          return (
            <div key={s.id || s.symbol} className="bg-[#121826] rounded-2xl border border-[#1E293B] overflow-hidden hover:border-[#F59E0B]/50 hover:shadow-[0_0_20px_rgba(245,158,11,0.1)] transition-all duration-300 group">
              <div className="relative h-40 bg-[#1E293B] flex items-center justify-center">
                {imgUrl ? (
                  <img src={imgUrl} alt={s.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
                ) : (
                  <span className="text-4xl font-black text-[#F59E0B]/20 font-mono">{s.symbol}</span>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#121826] via-transparent to-transparent" />
                <div className="absolute top-3 left-3 bg-[#F59E0B] text-black text-xs font-bold px-2 py-1 rounded font-mono">{s.symbol}</div>
              </div>
              <div className="p-4">
                <Link to={`/security/${s.symbol}`}>
                  <h3 className="text-[#F8FAFC] font-bold text-lg mb-1 hover:text-[#F59E0B] transition-colors font-heading truncate">{s.name}</h3>
                </Link>
                <p className="text-[#64748B] text-sm mb-3">{s.security_type === 'movie' ? 'MovieStock' : 'StarBond'}</p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-[#F8FAFC] font-bold text-xl font-mono">B₹{(s.price || 0).toFixed(2)}</span>
                    <div className={`text-sm font-mono font-medium flex items-center gap-1 mt-1 ${isUp ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
                      {isUp ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                      {isUp ? '+' : ''}{(s.change_percent || 0).toFixed(2)}%
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 pb-4">
                <Link to={`/security/${s.symbol}`}>
                  <Button className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-black font-semibold" data-testid={`trade-${s.symbol}-btn`}>Trade Now</Button>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OpeningThisWeek;
